import { getMswHandlers } from 'app/src/msw/msw'
import { setupWorker } from 'msw/browser'

export const worker = setupWorker(...getMswHandlers())
